<template>
    <v-dialog
        v-model="showDialog"
        width="600"
        :persistent="loading || msuCodes && msuCodes.length > 0"
    >
        <v-card v-if="data">
            <v-form
                ref="form"
                @submit.prevent="handleInsertToMsuGroup"
            >
                <v-card-title style="background-color: #009688; color: white; word-break: break-word;">
                    New MSU From Group&nbsp;<v-chip>{{ data.msuInfo.MSUGRP_ID }}</v-chip>
                </v-card-title>
                <v-card-text style="max-height: 70vh; overflow-y: scroll; background-color: #EDFFFB;">
                    <div style="background-color: white; border-radius: 20px; padding: 10px 10px 0  10px; margin-top: 25px">
                        <v-text-field
                            v-model="data.msuInfo.MSUGRP_ID"
                            label="MSU Group ID"
                            readonly
                        />
                        <v-autocomplete
                            v-model="msuCodes"
                            label="Hospital/Clinic Name"
                            :items="items"
                            item-text="nameAndCode"
                            item-value="ROW_N"
                            return-object
                            :multiple="true"
                            :rules="[msuCodes.length > 0 || 'This field is required']"
                        >
                            <!-- Custom template for selected clinic -->
                            <template #selection="item">
                                <v-chip
                                    style="display: inline-block; margin: 3px;"
                                    v-bind="item.attrs"
                                    :input-value="item.selected"
                                    close
                                    @click="item.select"
                                    @click:close="remove(item.item.hosp_msu_code)"
                                >
                                    <v-chip
                                        v-if="item.item.hosp_msu_code || item.item.group_id"
                                        small
                                        :color="item.item.type === 'SINGLE' ? 'teal' : 'blue'"
                                        class="white--text"
                                        style="font-weight: 700;"
                                    >
                                        {{ item.item.type === 'SINGLE' ? item.item.hosp_msu_code : item.item.group_id }}
                                    </v-chip> {{ item.item.hosp_name }}
                                </v-chip>
                            </template>
                        </v-autocomplete>
                    </div>
                </v-card-text>
                <v-card-actions style="background-color: #EDFFFB;">
                    <v-spacer />
                    <v-btn
                        outlined
                        class="white--text"
                        color="teal darken-1"
                        style="text-transform: none; width: 105px;"
                        @click="showDialog = false"
                    >
                        CLOSE
                    </v-btn>
                    <v-btn
                        color="teal darken-1 white--text"
                        class="white--text"
                        style="text-transform: none; width: 105px; font-weight: 600"
                        :loading="loading"
                        type="submit"
                    >
                        ADD
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['show', 'data', 'notif'],
    data: ()=>({
        items: [],
        loading: false,
        msuCodes: []
    }),
    computed: {
        ...mapGetters(['insertToMsuGroupData', 'fetchAcuProvidersData', 'viewMsuGroupData']),
        showDialog: {
            get() {
                this.loadAcuProviders()
                return this.show
            },
            set() {
                this.resetForm()
            }
        }
    },
    watch: {
        fetchAcuProvidersData(newVal) {
            if (newVal) {
                if (newVal.status === 200 && newVal.data && newVal.data.length > 0) {
                    if (this.data && this.data.groupInfo && this.data.groupInfo.members) {
                        this.items = []
                        const alreadyAddedClinic = this.data.groupInfo.members
                        let filteredArr = newVal.data
                            .filter(item => {
                                // Exclude item if its hosp_msu_code matches any alreadyAddedClinic.MSU_C
                                if (!item.group_id) {
                                    return !alreadyAddedClinic.some(clinic => (clinic.hosp_msu_code === item.hosp_msu_code))
                                }
                            })
                            .map(item => ({
                                ...item,
                                nameAndCode: `${item.hosp_msu_code} ${item.hosp_name}`
                            }))
                        this.items = filteredArr
                    }
                }
            }
            this.loading = false
        }
    },
    methods: {
        ...mapActions(['insertToMsuGroup', 'fetchAcuProviders', 'listMsuGroups', 'viewMsuGroup']),
        remove(msuCode) {
            const index = this.msuCodes.findIndex(item => item.hosp_msu_code === msuCode)
            this.msuCodes.splice(index, 1)
        },
        loadAcuProviders() {
            this.loading = true
            this.fetchAcuProviders()
        },
        resetForm() {
            this.$nextTick(()=>{
                this.msuCodes = []
                this.$refs.form.resetValidation()
                this.$emit('closeDialog')
            })
        },
        async handleInsertToMsuGroup() {
            if (this.$refs && this.$refs.form.validate()) {
                this.loading = true
                const promises = await this.msuCodes.map(async (item) => {
                    const params = {
                        MSUGRP_ID: this.data.msuInfo.MSUGRP_ID,
                        MSU_CODES: [item.hosp_msu_code]
                    }
                    return await this.insertToMsuGroup(params)
                })
                Promise
                    .all(promises)
                    .then(async () => {
                        await this.viewMsuGroup({ ID: this.data.msuInfo.MSUGRP_ID })
                        if (this.viewMsuGroupData.status === 200) {
                            this.notif.type = 'success'
                            this.notif.color = 'success'
                            this.notif.timeout = 5000
                            this.notif.msg = 'MSU has been added to the group.'
                            this.notif.show = true
                            this.showDialog = false
                            this.loading = false
                        } else {
                            this.notif.type = 'error'
                            this.notif.color = 'error'
                            this.notif.timeout = 5000
                            this.notif.msg = this.viewMsuGroupData.state
                            this.notif.show = true
                        }
                        // Handle success (e.g., show notification)
                    })
                    .catch(error => {
                        console.error(error)
                        // Handle error (e.g., show error message)
                    })
            }
        }
    }
}
</script>
